module.exports = __webpack_public_path__ + "media/src/images/h5p_docu_1-a15965951ddb4a2556277a2f8fa721ae.png";